<template>
    <div id="home" class="view" role="main">
        <div class="imgDiv">
            <img src="../../assets/wos/img/wos.jpg" alt />
        </div>
        <ul>
            <li>
                <div class="select-single-left">
                    <select class="select-left" v-model="select1">
                        <option v-for="item in options" v-bind:key="item.index" :value="item.value">{{ item.name }}</option>
                    </select>
                </div>
                <div class="select-input">
                    <input type="text" v-model="input1" placeholder="请输入" />
                </div>
            </li>
            <li>
                <div class="select-single-left">
                    <select class="select-left" v-model="select2">
                        <option v-for="item in options" v-bind:key="item.index" :value="item.value">{{ item.name }}</option>
                    </select>
                </div>
                <div class="select-input">
                    <input type="text" v-model="input2" placeholder="请输入" />
                </div>
            </li>
            <li>
                <div class="select-single-left">
                    <select class="select-left" v-model="select3">
                        <option v-for="item in options" v-bind:key="item.index" :value="item.value">{{ item.name }}</option>
                    </select>
                </div>
                <div class="select-input">
                    <input type="text" v-model="input3" placeholder="请输入" />
                </div>
            </li>
            <li>
                <div class="select-single-left">
                    <select class="select-left" v-model="select4">
                        <option v-for="item in options" v-bind:key="item.index" :value="item.value">{{ item.name }}</option>
                    </select>
                </div>
                <div class="select-input">
                    <input type="text" v-model="input4" placeholder="请输入" />
                </div>
            </li>
            <li>
                <div class="select-single-left">
                    <select class="select-left" v-model="select5">
                        <option v-for="item in options" v-bind:key="item.index" :value="item.value">{{ item.name }}</option>
                    </select>
                </div>
                <div class="select-input">
                    <input type="text" v-model="input5" placeholder="请输入" />
                </div>
            </li>
            <li>
                <div class="select-single">
                    <p class="jiansuoleixing">检索类型</p>
                    <select class="select-left2" v-model="searchType5">
                        <!-- <option v-for="(item,index) in searchType" :key="index" :value="item.val">{{item.title}}</option> -->
                        <option v-for="(item, index) in searchType" :key="index" :value="item.val">{{ item.title }}</option>
                    </select>
                </div>
            </li>
        </ul>
        <div class="md-example-child md-example-child-md-activity-indicator md-example-child-md-activity-indicator-2 single-button">
            <md-button type="primary" @click="createSearchList">
                <md-activity-indicator
                    v-if="loading"
                    class="md-activity-indicator-css"
                    type="carousel"
                    :size="15"
                    color="#fff"
                    text-color="#fff"
                ></md-activity-indicator>
                <span v-else>检索</span>
            </md-button>
        </div>
    </div>
</template>

<script>
//logo
import { Button, ActivityIndicator } from "mand-mobile";
//假数据
export default {
    name: "home-view",
    components: {
        [Button.name]: Button,
        [ActivityIndicator.name]: ActivityIndicator
    },
    data() {
        return {
            loading: false,
            //左侧select
            select1: "TS",
            select2: "TI",
            select3: "AU",
            select4: "SO",
            select5: "UT",
            //右侧select
            bool1: "AND",
            bool2: "AND",
            bool3: "AND",
            bool4: "AND",
            bool5: "AND",
            //input
            input1: "",
            input2: "",
            input3: "",
            input4: "",
            input5: "",
            searchType5: 1,
            //数据
            options: [
                {
                    name: "主题",
                    value: "TS"
                },
                {
                    name: "标题",
                    value: "TI"
                },
                {
                    name: "作者",
                    value: "AU"
                },
                {
                    name: "出版物名称",
                    value: "SO"
                },
                {
                    name: "出版年",
                    value: "PY"
                },
                {
                    name: "入藏号",
                    value: "UT"
                },
                {
                    name: "地址",
                    value: "AD"
                }
            ],
            searchType: [
                { title: "wos核心集", val: 1 },
                { title: "biosis", val: 2 }
            ]
            //   searchType: ['wos核心集', 'biosis']
        };
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: false, title: "", iconType: false });
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            // 通过 `vm` 访问组件实例
            if (from.path === "/searchlist") {
                vm.$router.go(0);
            }
        });
    },
    methods: {
        createSearchList() {
            this.loading = false;
            let url = "";
            if (this.input1.length !== 0) {
                url += "input1=" + this.input1 + "&sel1=" + this.select1;
                //url += 'input1=' + this.input1;
            }
            if (this.input2.length !== 0) {
                url += "&input2=" + this.input2 + "&sel2=" + this.select2;
            }
            if (this.input3.length !== 0) {
                url += "&input3=" + this.input3 + "&sel3=" + this.select3;
            }
            if (this.input4.length !== 0) {
                url += "&input4=" + this.input4 + "&sel4=" + this.select4;
            }
            if (this.input5.length !== 0) {
                // url += '&input5=' + this.input5 + '&select5=' + this.select5 + '&bool1=' + this.bool5;
                url += "&input5=" + this.input5 + "&sel5=" + this.select5;
            }
            url += "&searchType=" + this.searchType5;
            let params = {
                url: url
            };
            this.loading = true;
            this.$router.push({ path: "/wosList", query: params });
        }
    }
};
</script>

<style scoped>
.logo-box {
    margin-top: 110px;
    width: 100%;
    display: table;
    height: auto;
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
}

.logo-box img {
    display: block;
    width: 50%;
    height: auto;
    margin: 0 auto;
}

.imgDiv img {
    width: 100%;
    height: 5.33333rem;
}

#home ul {
    display: table;
    width: 100%;
}

#home ul li {
    display: table;
    width: 100%;
    margin-top: 10px;
}

.select-single-left {
    font-size: 16px;
    float: left;
    width: 29%;
}

.select-single {
    width: 100%;
    margin-top: 10px;
}

.select-input {
    font-size: 16px;
    float: left;
    width: 70%;
}

.select-single-right {
    font-size: 16px;
    float: right;
    width: 15%;
}

.select-left {
    text-align: center;
    padding-left: 0;
    font-size: 16px;
    width: 90%;
    float: left;
    height: 40px;
    border: none;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: #fff;
    outline: 0;
    background: url("../../assets/img/dao.png") no-repeat;
    background-position-x: 0%;
    background-position-y: 0%;
    background-position-x: 0%;
    background-position-y: 0%;
    background-position-x: 0;
    background-position-y: 0;
    background-position: right 19px;
    padding: 0 15px;
}
.select-left2 {
    text-align: center;
    padding-left: 0;
    font-size: 16px;
    width: 30%;
    float: left;
    height: 40px;
    border: none;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: #fff;
    outline: 0;
    background: url("../../assets/img/dao.png") no-repeat;
    background-position-x: 0%;
    background-position-y: 0%;
    background-position-x: 0%;
    background-position-y: 0%;
    background-position-x: 0;
    background-position-y: 0;
    background-position: right 19px;
}
.select-right {
    text-align: center;
    padding-left: 10%;
    font-size: 16px;
    width: 90%;
    float: left;
    height: 50px;
    border: none;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: #fff;
    outline: 0;
    background: url("../../assets/img/dao.png") no-repeat;
    background-position-x: 0%;
    background-position-y: 0%;
    background-position-x: 0%;
    background-position-y: 0%;
    background-position-x: 0;
    background-position-y: 0;
    background-position: right 19px;
}

.select-input input {
    font-size: 16px;
    width: 96%;
    display: table;
    padding-left: 4%;
    height: 40px;
    border: none;
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
}

option {
    text-align: center;
}

.time {
    width: 22%;
    text-align: center;
    font-size: 16px;
    line-height: 40px;
    float: left;
}

.time2 {
    text-align: center;
    font-size: 16px;
    line-height: 40px;
    float: left;
    width: 1rem;
}

.startyear {
    margin-left: 35px;
}

.endyear {
    margin-left: 10px;
}

.startyear,
.endyear {
    font-size: 16px;
    width: 150px;
    float: left;
    height: 40px;
    border: none;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: #fff;
    outline: 0;
    background: url("../../assets/img/dao.png") no-repeat;
    background-position-x: 0%;
    background-position-y: 0%;
    background-position-x: 0%;
    background-position-y: 0%;
    background-position-x: 0;
    background-position-y: 0;
    background-position: right 19px;
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
}

.single-button button {
    height: 50px;
    font-size: 20px;
    width: 50%;
    margin: 100px auto auto auto;
    background-color: #305359;
}

.jiansuoleixing {
    float: left;
    font-size: 16px;
    height: 40px;
    width: 30%;
    /* text-align: center; */
    line-height: 40px;
    padding: 0 15px;
}
</style>
